import { useQuery } from '@apollo/client';
import { Card, Paragraph, token } from '@zillow/constellation';
import React from 'react';
import styled from 'styled-components';
import useQueryVariables from '../../../../hooks/useQueryVariables';
import { formatApplicantsNames } from '../../../../utils/formatLogicUtil';
import { getInvitationInfo, INVITE_TO_MOVE_IN_QUERY } from '../../../../utils/inviteToMoveIn';

// TODO - Make this an Upsell component from Constellation
const CoapplicantBody = styled(Card)`
  background-color: ${token('colors.blue100')};
  width: 100%;
  border: none;
`;

export default function CoapplicantSection() {
  const variables = useQueryVariables();
  const { data, loading, error } = useQuery(INVITE_TO_MOVE_IN_QUERY, { variables });
  const { applicants, street } = getInvitationInfo(data);
  if (loading || error) {
    return null;
  }
  const formattedNames = formatApplicantsNames({
    applicants,
    defaultText: "the applicant's",
    defaultTextPlural: "the applicants'",
    addPossessiveAffixExcludingDefaults: true,
  });
  return (
    <>
      <CoapplicantBody
        {...{
          cardElevation: 0,
          cardType: 'secondary',
          marginBottom: 'lg',
        }}
      >
        <Paragraph marginBottom="sm">
          {`You will approve ${formattedNames} application for `}
          <b>{street}</b> by sending them a message.
        </Paragraph>
        <Paragraph>
          Customize your invitation message below to let them know the good news and next steps for securing your
          rental.
        </Paragraph>
      </CoapplicantBody>
    </>
  );
}
